import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import { verifySsnAndDobApi, forgotPinPasswordLinkApi } from '../../services/authApi/forgotPinApi';
import { toastNotify } from '../../utils/toastNotify';
import { checkYearValid } from '../../utils/checkYearValid';
import './ForgotPIN.scss';

const ForgotPIN = () => {
  const [ssn, setSSN] = useState();
  const [birthYear, setBirthYear] = useState();
  const [viewForm, setViewForm] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  let navigate = useNavigate();

  const sendVerificationLink = async(phoneNumber) => {
    let formData = {
      email: localStorage.getItem("email"),
      phoneNumber: phoneNumber,
      credentialType: "pinAndPassword"
    }
    try {
      const userData = await forgotPinPasswordLinkApi(formData);
      if (!userData.isError) {
        navigate('/forgot-pin/request-reset');
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  const onFinish = async(values) => {
    setLoading(true);
    let formData = {...values, email: localStorage.getItem("email")}
    try {
      const userData = await verifySsnAndDobApi(formData);
      if (!userData.isError) {
        let phoneNumber = userData.data.phoneNumber
        localStorage.setItem("phoneNumber", phoneNumber)
        sendVerificationLink(phoneNumber);
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  }
  return (
    <div className='auth auth--details auth--no-info-mobile login'>
      <AuthInfo
        className={viewForm ? 'hide' : null}
        title={<>Welcome back</>}
        description={<>Enter your credentials to access your Realbricks account.</>}
      >
        <div className='mobile-action' onClick={() => setViewForm(true)}>
          <Button className='w-100'>Get Started</Button>
        </div>
      </AuthInfo>
      <AuthForm
        className={viewForm ? 'show' : null}
        title={<>Forgot your 4-digit PIN?</>}
        description={<>In order to help us verify your identity, please enter the personal information associated with your account.</>}
      >
        <Form 
          onFinish={onFinish}
          className='auth-form'
          autoComplete='off'
          form={form}
        >
          <p>What are the last 4 digits of your social security number?</p>
          <FloatingLabel label='Last 4 digits of SSN' name='ssn' inputValue={ssn}>
            <Form.Item 
              name='ssn'
              rules={[
                { required: true, message: 'Please enter your SSN.' },
                {
                  min: 4,
                  message: 'value must be of 4 charcters',
                },
              ]}
            >
              <Input 
                placeholder='XXXX' 
                value={ssn} 
                maxLength={4}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={(e) => setSSN(e.target.value)} 
              />
            </Form.Item>
          </FloatingLabel>
          <p>What is your birth year?</p>
          <FloatingLabel 
            label='Birth year' 
            className='small-input' 
            name='birthYear' 
            inputValue={birthYear}
          >
            <Form.Item 
              name='birthYear'
              rules={[
                {
                  validator: (_, value) => checkYearValid(value)
                }
              ]}
            >
              <Input 
                placeholder='YYYY' 
                value={birthYear} 
                maxLength={4}
                onChange={(e) => setBirthYear(e.target.value)} 
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </FloatingLabel>
          <Form.Item className='auth-form__fixed-submit' shouldUpdate>
            {() => (
              <Button  
                htmlType='submit' 
                type='primary' 
                className='ant-btn-primary--alt'
                loading={loading}
                disabled={
                  !form.isFieldsTouched(true) || 
                  form.getFieldsError().filter(({ errors }) => errors.length).length > 0
                }
              >
                Submit
              </Button>
            )}
          </Form.Item>
        </Form>
      </AuthForm>
    </div>
  );
};

export default ForgotPIN;